export class ReceivingInstructionFilesRequest {
    docIds: string[];
    userName: string;
  
    constructor() {
      this.docIds = [];
      this.userName = "";
    }
}